{
  "age": "Age",
  "complianceState": "Compliance State",
  "dateOfBirth": "Date of Birth",
  "marketValue": "Market Value",
  "createdAt": "Created At",
  "state": "State",
  "accountType": "Account Type",
  "goalType": "Goal Type",
  "jurisdiction": "Jurisdiction",
  "user": "Clients",
  "account": "Accounts",
  "language": "Language",
  "isOfficerOfPublicCompany": "Is Officer of Public Company",
  "isOwnerOfPublicCompany": "Is Owner of Public Company",
  "isMemberOfIiroc": "Is Member of IIROC",
  "politicallyExposedForeignPerson": "Is Politically Exposed Foreign Person",
  "politicallyExposedDomesticPerson": "Is Politically Exposed Domestic Person",
  "closeAssociateOfPEP": "Is Close Associate of PEP",
  "isAccreditedInvestor": "Is Accredited Investor",
  "powerOfAttorneyGranted": "Power of Attorney Granted",
  "headOfInternationalOrganization": "Head of International Organization",
  "isRelatedToAdvisor": "Is Related to Advisor",
  "isVulnerablePerson": "Is Vulnerable Person",
  "isOwnerOfEntity": "Is Owner of Entity",
  "amount": "Amount",
  "source": "Source",
  "type": "Type",
  "withdrawalReason": "Withdrawal Reason",
  "applyForGovFunds": "Apply for Government Funds",
  "countryOfTaxResidence": "Country of Tax Residence",
  "paysForeignTaxes": "Pays Foreign Taxes",
  "accountJurisdiction": "Account Jurisdiction",
  "advisorInterest": "Advisor Interest",
  "investmentFirmTrade": "Investment Firm Trade",
  "useBorrowedMoney": "Use Borrowed Money",
  "isReportingIssuer": "Is Reporting Issuer",
  "tradingAuthorityOverAccountGranted": "Trading Authority Over Account Granted"
}
